var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container is-fluid"},[_c('keep-alive',{attrs:{"exclude":"stock-detail"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }